module.exports = __webpack_public_path__ + "static/notifications-21dcd4ba11e69c3af4982c9bcd190808.mp4";